// Mock data pour InfraOne - Transport industriel & Location d'engins lourds
// Cible : Mines, Agro-industrie, Logistique portuaire au Gabon

export const companyInfo = {
  name: "InfraOne",
  tagline: "Transport industriel & location d'engins lourds — Au service des leaders miniers et agro-industriels au Gabon",
  shortTagline: "Votre partenaire logistique pour les industries lourdes au Gabon",
  description:
    "InfraOne accompagne les groupes miniers, forestiers et agro-industriels du Gabon dans le transport de matières premières et la location d'engins lourds. Fiabilité, traçabilité GPS et disponibilité 24/7 sur tous les axes : Moanda, Owendo, Franceville, Port-Gentil.",
  location: "Libreville, Gabon",
  phone: "(+241) 74754771",
  phone2: "(+241) 60456990",
  phone3: "(+241) 65300284",
  phoneInternational: "(+33) 669448351",
  email: "contact@infraone.ga",
  quoteEmail: "contact@infraone.ga",
  address: "Zone Industrielle d'Oloumi, Libreville",
  zonesIntervention: [
    "Estuaire (Libreville, Owendo, Kango)",
    "Haut-Ogooué (Moanda, Franceville, Mounana)",
    "Ogooué-Maritime (Port-Gentil, Gamba)",
    "Ngounié (Mouila, Fougamou)",
    "Woleu-Ntem (Oyem, Bitam)",
    "Moyen-Ogooué (Lambaréné)"
  ]
};

// Clients de référence (entreprises servies)
export const clients = [
  {
    id: 1,
    name: "Olam Palm Gabon",
    sector: "Agro-industrie - Huile de palme",
    description: "Acheminement de conteneurs d'huile brute et de régimes de palme"
  },
  {
    id: 2,
    name: "Comilog Gabon",
    sector: "Mines - Manganèse",
    description: "Transport de minerai de manganèse depuis Moanda"
  },
  {
    id: 3,
    name: "Société Équatoriale des Mines",
    sector: "Mines - Métaux de base",
    description: "Convois exceptionnels et logistique minière"
  },
  {
    id: 4,
    name: "Gabon Logistique Portuaire",
    sector: "Logistique - Port d'Owendo",
    description: "Pré et post-acheminement portuaire"
  }
];

// 3 services clés
export const services = [
  {
    id: 1,
    icon: "truck",
    title: "Transport de matières premières",
    short: "Camions bennes, porte-conteneurs, citernes et convois exceptionnels.",
    description:
      "Acheminement sécurisé et tracé de minerai, grumes, huile de palme, granulats et matériaux industriels sur les axes Moanda – Owendo, Franceville – Port-Gentil et l'ensemble du territoire gabonais.",
    details: [
      "Camions bennes 6×4 et 8×4 (capacité 25 à 40 t)",
      "Semi-remorques porte-conteneurs 20' / 40'",
      "Citernes transport huile de palme et hydrocarbures",
      "Convois exceptionnels et hors gabarit",
      "Transport de grumes et bois équarri",
      "Reporting GPS et bordereaux numériques"
    ],
    typicalGoods: [
      "Minerai de manganèse",
      "Huile de palme brute",
      "Grumes & bois transformé",
      "Granulats et matériaux BTP",
      "Conteneurs maritimes"
    ]
  },
  {
    id: 2,
    icon: "construction",
    title: "Location d'engins lourds",
    short: "Bulldozers, chargeuses, pelles, grues — avec chauffeur ou en autonome.",
    description:
      "Mise à disposition d'un parc d'engins lourds modernes pour vos chantiers miniers, forestiers, agricoles ou de génie civil. Tous nos engins sont entretenus en atelier intégré et disponibles avec conducteurs expérimentés.",
    details: [
      "Bulldozers (Caterpillar D6, D8)",
      "Chargeuses sur pneus (Cat 966, 980)",
      "Pelles hydrauliques (320, 336, 349)",
      "Niveleuses (140K, 14M)",
      "Tombereaux rigides Caterpillar (90 t)",
      "Compacteurs de sol et de finition",
      "Grues mobiles 25 à 80 t"
    ],
    typicalGoods: []
  },
  {
    id: 3,
    icon: "shield-check",
    title: "Prestations logistiques clé en main",
    short: "Gestion de parc, maintenance, suivi GPS et assistance 24/7.",
    description:
      "Au-delà du transport, nous prenons en charge la gestion complète de votre logistique : planification des rotations, conducteurs certifiés, maintenance préventive, et reporting temps réel pour vos équipes d'audit et de production.",
    details: [
      "Mise à disposition de conducteurs expérimentés (permis EC, CACES)",
      "Suivi GPS et géofencing temps réel",
      "Assistance dépannage 24/7 sur tout le Gabon",
      "Contrats courts (chantier) ou longs (annuels)",
      "Reporting mensuel disponibilité & tonnage",
      "Conformité HSE et normes ISO en vigueur"
    ],
    typicalGoods: []
  }
];

// Réalisations / études de cas
export const projects = [
  {
    id: 1,
    title: "Transport de 150 000 t de manganèse — Moanda → Owendo",
    category: "Mines",
    client: "Comilog Gabon",
    description:
      "Convois cadencés de minerai de manganèse depuis Moanda jusqu'au port d'Owendo, sur 770 km. Respect des délais contractuels et zéro incident HSE sur 12 mois d'exploitation.",
    year: "2024",
    duration: "12 mois",
    kpis: ["150 000 t transportées", "0 incident HSE", "98 % disponibilité flotte"]
  },
  {
    id: 2,
    title: "Acheminement huile de palme brute vers l'usine de Kango",
    category: "Agro-industrie",
    client: "Olam Palm Gabon",
    description:
      "Citernes dédiées pour le transport d'huile de palme brute depuis les plantations vers l'unité de raffinage de Kango. Solution end-to-end incluant lavage, traçabilité et bordereaux numériques.",
    year: "2024",
    duration: "Contrat annuel",
    kpis: ["48 000 t/an d'huile", "Citernes inox dédiées", "Traçabilité ISO 22000"]
  },
  {
    id: 3,
    title: "Convois exceptionnels — équipements miniers SEM",
    category: "Mines",
    client: "Société Équatoriale des Mines",
    description:
      "Déplacement d'équipements miniers hors gabarit (pelles 350t, concasseurs) entre sites d'exploitation. Étude de tracé, escortes, autorisations administratives prises en charge.",
    year: "2023",
    duration: "4 mois",
    kpis: ["12 convois exceptionnels", "Largeur > 6 m", "Autorisations clé en main"]
  },
  {
    id: 4,
    title: "Pré/post-acheminement portuaire Owendo",
    category: "Logistique",
    client: "Gabon Logistique Portuaire",
    description:
      "Service quotidien de pré et post-acheminement de conteneurs entre le port d'Owendo et les zones industrielles de Libreville. Flotte dédiée 24/7.",
    year: "2023",
    duration: "Contrat pluriannuel",
    kpis: ["+ 8 000 EVP/an", "Disponibilité 24/7", "Slot booking digital"]
  },
  {
    id: 5,
    title: "Location longue durée — chantier forestier Ngounié",
    category: "Bois",
    client: "Exploitant forestier confidentiel",
    description:
      "Mise à disposition de 6 chargeuses, 4 bulldozers et 12 grumiers avec équipages complets pour l'exploitation d'une concession forestière en Ngounié.",
    year: "2023",
    duration: "18 mois",
    kpis: ["22 engins déployés", "Équipages H24", "Maintenance sur site"]
  },
  {
    id: 6,
    title: "Transport de granulats — chantier BTP Port-Gentil",
    category: "BTP",
    client: "Groupement BTP régional",
    description:
      "Rotations quotidiennes de granulats et matériaux entre carrières et chantiers de construction à Port-Gentil. Pic d'activité géré à plus de 80 rotations/jour.",
    year: "2022",
    duration: "9 mois",
    kpis: ["320 000 t transportées", "80 rotations/jour pic", "98 % ponctualité"]
  }
];

// Chiffres clés affichés dans le bandeau
export const stats = [
  { number: "+50", label: "Engins opérationnels" },
  { number: "+200 000 t", label: "Transportées par an" },
  { number: "98 %", label: "Taux de disponibilité" },
  { number: "24/7", label: "Assistance terrain" }
];

// Parc d'engins (avec placeholders pour images)
// Le client renommera ses photos selon le champ `imageName` pour les voir apparaître.
export const fleet = [
  {
    id: 1,
    category: "Camion benne",
    name: "Camion benne 8×4",
    capacity: "40 t — 22 m³",
    year: "2022",
    usage: "Transport granulats, minerai, terre",
    imageName: "truck-benne-01.jpg"
  },
  {
    id: 2,
    category: "Semi-remorque",
    name: "Tracteur + porte-conteneurs 40'",
    capacity: "2 × 20' ou 1 × 40' (32 t)",
    year: "2023",
    usage: "Conteneurs maritimes, transport portuaire",
    imageName: "semi-container-01.jpg"
  },
  {
    id: 3,
    category: "Citerne",
    name: "Citerne inox 32 000 L",
    capacity: "32 m³",
    year: "2022",
    usage: "Huile de palme, produits alimentaires",
    imageName: "tanker-palm-oil-01.jpg"
  },
  {
    id: 4,
    category: "Grumier",
    name: "Grumier 6×6 + remorque",
    capacity: "55 t bois",
    year: "2021",
    usage: "Transport de grumes en zone forestière",
    imageName: "logging-truck-01.jpg"
  },
  {
    id: 5,
    category: "Bulldozer",
    name: "Bulldozer Caterpillar D8",
    capacity: "Lame 4.5 m — 38 t",
    year: "2022",
    usage: "Décapage, terrassement, pistes minières",
    imageName: "bulldozer-cat-d8.jpg"
  },
  {
    id: 6,
    category: "Chargeuse",
    name: "Chargeuse sur pneus Cat 980",
    capacity: "Godet 5.4 m³ — 32 t",
    year: "2023",
    usage: "Chargement carrière, manutention vrac",
    imageName: "wheel-loader-cat-980.jpg"
  },
  {
    id: 7,
    category: "Pelle hydraulique",
    name: "Pelle hydraulique Cat 349",
    capacity: "Godet 2.5 m³ — 49 t",
    year: "2022",
    usage: "Excavation, chargement, démolition",
    imageName: "excavator-cat-349.jpg"
  },
  {
    id: 8,
    category: "Niveleuse",
    name: "Niveleuse Caterpillar 140K",
    capacity: "Lame 3.7 m — 18 t",
    year: "2021",
    usage: "Profilage pistes, entretien routes",
    imageName: "grader-cat-140k.jpg"
  },
  {
    id: 9,
    category: "Tombereau rigide",
    name: "Tombereau rigide Caterpillar",
    capacity: "90 t charge utile",
    year: "2023",
    usage: "Transport minier — fosse à concasseur",
    imageName: "articulated-dump-bell-b40.jpg"
  },
  {
    id: 10,
    category: "Compacteur",
    name: "Compacteur tandem 12 t",
    capacity: "Bille 2.1 m",
    year: "2022",
    usage: "Compactage routes & plateformes",
    imageName: "compactor-tandem-01.jpg"
  },
  {
    id: 11,
    category: "Grue mobile",
    name: "Grue mobile 80 t",
    capacity: "Flèche 50 m — 80 t",
    year: "2021",
    usage: "Levage industriel, montage charpente",
    imageName: "mobile-crane-80t.jpg"
  },
  {
    id: 12,
    category: "Convoi exceptionnel",
    name: "Plateau surbaissé 120 t",
    capacity: "120 t — 8 essieux",
    year: "2023",
    usage: "Transport engins lourds & hors gabarit",
    imageName: "lowboy-trailer-01.jpg"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Direction Logistique",
    position: "Responsable Supply Chain",
    company: "Groupe minier — Haut-Ogooué",
    content:
      "InfraOne nous apporte une régularité exemplaire sur l'axe Moanda – Owendo. La traçabilité GPS et le reporting mensuel sont devenus indispensables à nos audits internes.",
    rating: 5
  },
  {
    id: 2,
    name: "Directeur d'exploitation",
    position: "Directeur Exploitation",
    company: "Acteur agro-industriel — Estuaire",
    content:
      "Les citernes dédiées d'InfraOne respectent nos protocoles sanitaires. Zéro contamination croisée en 18 mois, et une réactivité impressionnante en pleine saison.",
    rating: 5
  },
  {
    id: 3,
    name: "Chef de chantier",
    position: "Chef de Chantier",
    company: "Concession forestière — Ngounié",
    content:
      "Les engins sont entretenus avec sérieux, et les équipages connaissent parfaitement le terrain gabonais. Notre productivité a bondi de 22 % sur la saison.",
    rating: 5
  }
];

export const certifications = [
  "ISO 9001:2015 — Management de la Qualité",
  "ISO 14001:2015 — Management Environnemental",
  "ISO 45001 — Santé & Sécurité au Travail",
  "Agrément Transport — Ministère gabonais"
];

export const values = [
  {
    icon: "shield-check",
    title: "Sécurité",
    description: "Standards HSE stricts, conducteurs certifiés, suivi 24/7 de chaque convoi."
  },
  {
    icon: "clock",
    title: "Réactivité",
    description: "Disponibilité 24/7 et capacité de mobilisation rapide sur tout le Gabon."
  },
  {
    icon: "map-pin",
    title: "Traçabilité",
    description: "GPS, géofencing et bordereaux numériques — vos audits sont nos alliés."
  },
  {
    icon: "handshake",
    title: "Engagement",
    description: "Contrats fermes, KPIs mesurables, transparence totale sur la performance."
  }
];
